import React from "react";
import { getVoteStats } from "./vote-utils";

export const PivCard = ({ data, name }: any) => {
    const { total, voted, notVoted } = getVoteStats(data);

    const partyData = data?.gotv_party;

    const hasPartyData = partyData && Object.keys(partyData).length > 0;

    return (
        <div className="rounded-xl border bg-white p-4 shadow-sm transition hover:shadow-md">
            <div className="text-sm text-gray-400">Ward</div>
            <div className="text-lg font-bold">{name}</div>

            <div className="mt-4 grid grid-cols-3 text-center">
                <div>
                    <div className="text-xs text-gray-400">Total</div>
                    <div className="font-bold">{total}</div>
                </div>

                <div>
                    <div className="text-xs text-gray-400">Polled</div>
                    <div className="font-bold text-green-600">{voted}</div>
                </div>

                <div>
                    <div className="text-xs text-gray-400">Not Voted</div>
                    <div className="font-bold text-red-600">{notVoted}</div>
                </div>
            </div>
            {hasPartyData && (
                <div className="mt-3 border-t pt-2 text-xs">
                    {Object.entries(partyData).map(([party, val]: any) => (
                        <div key={party} className="flex justify-between">
                            <span>{party}</span>
                            <span>{val}</span>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};
